import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import fitness from "../../Assets/Projects/fitness.png";
import youtube from "../../Assets/Projects/youtube.png";
import chatify from "../../Assets/Projects/chat-app.png";
import Dashboard from "../../Assets/Projects/react-dashboard.png";
import Nike from "../../Assets/Projects/nike-landing.png";
import ecommerce from "../../Assets/Projects/e-commerce.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Full-Stack Chat App"
              description="A dynamic chat application built with the MERN stack, featuring real-time messaging powered by Socket.io, responsive design with TailwindCSS and Daisy UI, global state management using Zustand, and Cloudinary integration for image uploads. Includes authentication, user status tracking, and robust error handling. Fully deployable with a detailed setup guide."
              ghLink="https://github.com/mohamedsaeed22/fullstack-chat-app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Dashboard}
              isBlog={false}
              title="React Dashboard"
              description="Developed a responsive and interactive dashboard application using React, incorporating various Syncfusion components for enhanced functionality. Integrated statistical dashboards and detailed project views using Chart.js and MUI components. Utilized TailwindCSS for rapid UI development and consistent design across the application."
              ghLink="https://github.com/mohamedsaeed22/dashboard-reactjs"
              demoLink="https://reactjs-dashboard-tailwindcss.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fitness}
              isBlog={false}
              title=" Fitness App"
              description="Built a responsive dashboard with Syncfusion, Chart.js, and MUI for data visualization. Used TailwindCSS for a sleek UI. Also developed a fitness app for exploring exercises, equipment, and workout videos, leveraging React, MUI 5, Redux Toolkit, and Rapid API for seamless UX."
              ghLink="https://github.com/mohamedsaeed22/fitness"
              demoLink="https://mosaeed-fitnessapp.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={youtube}
              isBlog={false}
              title="YouTube Clone"
              description="Developed a YouTube clone website with features like video search, category selection, video playback, and displaying related videos and channels. Utilized React JS and Material UI 5 to create a responsive and user-friendly interface. Implemented navigation with React-Router-Dom and used Axios with Rapid API for fetching and displaying video data. Tools Used: React JS, Material UI 5, React-Router-Dom, Axios, Rapid API."
              ghLink="https://github.com/mohamedsaeed22/youtube_clone"
              demoLink="https://mohamedsaeed-youtubeclone.netlify.app/"
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fitness} // Replace with the actual image path for the Todo App project
              isBlog={false}
              title="Next.js Todo App"
              description="This is a simple Todo application built with Next.js. It allows users to add, edit, and delete tasks. Features include authentication, adding new tasks, editing existing tasks, deleting tasks, marking tasks as completed, and dark/light theme. Technologies Used: Next.js, TypeScript, Prisma (MongoDB), React-hook-form, Tailwind CSS (shadcn/ui), Zod, and Clerk."
              ghLink="https://github.com/your-username/nextjs-todo-app" // Replace with your actual GitHub link
              demoLink="https://your-todo-app-demo-link.com" // Replace with your actual demo link (if available)
            />
          </Col> */}

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ecommerce}
              isBlog={false}
              title="E-Commerce Website"
              description="ITI Project ,A fully functional e-commerce website with features like product filtering, adding products to cart, cart management, and form validation. Includes 4 pages: Home, About, Contact Us, and Cart. Responsive on all screens. Tools Used: HTML5, CSS3, and JavaScript."
              ghLink="https://github.com/mohamedsaeed22/ITI_Project-E-Commerce"
              demoLink="https://iti-ecommerce-project.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Nike}
              isBlog={false}
              title="Nike Landing Page"
              description="This is a modern, responsive Nike landing page built with React, Vite, and Tailwind CSS. The project showcases a sleek design for a Nike shoe product line, demonstrating best practices in modern web development. Technologies Used: React, Vite, and Tailwind CSS."
              ghLink="https://github.com/mohamedsaeed22/nike-landing-page"
              demoLink="https://nike-react-vite.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
